import { render, staticRenderFns } from "./Reagent.vue?vue&type=template&id=1126f2d8&scoped=true"
import script from "./Reagent.vue?vue&type=script&lang=js"
export * from "./Reagent.vue?vue&type=script&lang=js"
import style0 from "./Reagent.vue?vue&type=style&index=0&id=1126f2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126f2d8",
  null
  
)

export default component.exports